module.exports = __webpack_public_path__ + "img/iwwa_file-csv.52c1d51a.svg";